<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Relevés de compte"
      subtitle="Recherche de relevés de compte"
      autocomplete_idHistory="account-statements"
      autocomplete_field="creancier.nom_soc || creancier.(nom prenom) || releve_compte.ID"
      bdTable="releve_compte"
      ref="releve_resource"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      :nobreadcrumb="nobreadcrumb"
      :hiddenFilter="hiddenFilter"
      :nosearch="nosearch"
      :directLoad="true"
    >

      <template v-slot:cell(ID)="data">
        {{ data.item.ID }}
      </template>
      <template v-slot:cell(balance)="data">
        <b class="text-success" v-if="data.value >= 0"
          >{{ Number(data.value).toFixed(2) }} €</b
        >
        <b class="text-danger" v-else>{{ Number(data.value).toFixed(2) }} €</b>
      </template>
     
      <template v-slot:cell(factureID)="data">
        <b-link
          v-if="data.value"
          :to="{ name: 'invoiceView', params: { id: data.value } }"
          >{{ data.value }}</b-link
        >
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
   
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import accountStatements from "@/services/account-statements.js";
export default {
  name: "AccountStatements",
  props: {
    nobreadcrumb: {
      type: Boolean,
      default: false,
    },
    nofacets: {
      type: Boolean,
      default: true,
    },
    hiddenFilter: String,
    nosearch: {
      type: Boolean,
      default: false,
    },
    creancierID: String
  },
  components: {
    BdTableList
  },
  methods: {
   
    
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
  data() {
    return {
      Api: accountStatements,
      releve_id: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Relevés de compte",
          active: true,
        },
      ],
      actions: [
        {
          label: "Imprimer",
          href:
            this.$store.getters.url +
            "/client/account-statement/{id}/pdf?token=" +
            encodeURIComponent(localStorage.getItem("vue-token")),
          icon: 'printer-fill',
          variant: 'info'
        },
      ],
      fields: [
        {
          key: "ID",
          label: "N° de relevé",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px",
        },
        {
          key: "date_creation",
          label: "Date",
          sortable: true,
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "report",
          label: "Solde précédent",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalCreancier",
          label: "Total créancier",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalChezNous",
          label: "Total chez nous",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalChezVous",
          label: "Total chez vous",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "balance",
          label: "Balance",
          sortable: true,
          class: "text-right",
        },
        {
          key: "factureID",
          label: "N° de facture",
          sortable: true,
          class: "text-right",
        },
        {
          key: "factureDate",
          label: "Date de facture",
          sortable: true,
          class:'text-center',
          formatter: (value, key, item) => {
            return item.factureID ? this.toDate(value) : "N/A";
          },
        },
        {
          key: "prixTVAC",
          label: "Montant de la facture (TVAC)",
          sortable: true,
          formatter: (value) =>
            value ? Number(value).toFixed(2) + " €" : "N/A",
          class: "text-right",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: { width: '150px' },
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>